export default __webpack_public_path__ + "static/media/hearticon.45e8d66f.gif";